const sectionExclusionList = ["info", "help"];
const isExcludedFromCMP = (pageSection) => {
    return sectionExclusionList.some((section) => section === pageSection);
};
export { isExcludedFromCMP };
